<ul class="nav nav-tabs" id="myTab" role="tablist">
  <li class="nav-item" role="presentation" [class.d-none]="idTareaWf==-1">
    <a class="nav-link fw-bold" [class.active]="activeTab === 'task-comp'"
       (click)="activeTab='task-comp'">{{ 'dataform.tab_option.task_component'|translate }}</a>
  </li>
  <li class="nav-item" role="presentation">
    <a class="nav-link fw-bold" [class.active]="activeTab === 'all-comp'"
       (click)="activeTab='all-comp'">{{ 'dataform.tab_option.all_component'|translate }}</a>
  </li>
</ul>
<div class="tab-content" id="myTabContent">
  <div class="tab-pane fade pt-2"
       [class.show]="activeTab === 'task-comp'"
       [class.active]="activeTab === 'task-comp'"
       [class.d-none]="idTareaWf==-1"
  >
    <app-detail-component
      [validUser]="validUser"
      [projectId]="projectId"
      [readonly]="readonly"
      [idtareawf]="idTareaWf"
      [typeProcess]="process"
      [username]="username"
      [language]="language"
    ></app-detail-component>
  </div>
  <div class="tab-pane fade pt-2"
       [class.show]="activeTab === 'all-comp'"
       [class.active]="activeTab === 'all-comp'">
    <app-detail-component
      [validUser]="validUser"
      [projectId]="projectId"
      [readonly]="readonly"
      [idtareawf]="-1"
      [typeProcess]="process"
      [username]="username"
      [language]="language"
    ></app-detail-component>
  </div>
</div>



